import React from "react";
import Section from "./Section";
import Container from "react-bootstrap/Container";
import SectionHeader from "./SectionHeader";
import SignUp from "./SignUp";
import {LoginSignupForm} from 'components/AccountButton'
import { useRouter } from "./../util/router.js";

function LoginSignUpSection(props) {
  const router = useRouter();

  // afterAuthPath={props.afterAuthPath}

  console.log("after auth path: ", props.afterAuthPath)

  // Go to page after signup
  const onComplete = () => {
    if (props?.afterAuthPath) {
      router.push(props.afterAuthPath)
    } else if (router?.query?.next) {
      router.push(decodeURIComponent(router.query.next));
    } else {
      router.push("/dashboard");
    }
    
  };

  return (
    <Section
      bg={props.bg}
      textColor={props.textColor}
      size={props.size}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
    >
      <Container
        style={{
          maxWidth: "850px"
        }}
      >
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={2}
          spaced={true}
          className="text-center"
        ></SectionHeader>
        <LoginSignupForm
        hideTitle={true}
        mode="signup"
        onComplete={onComplete}
        inputSize={props.inputSize}
        >

        </LoginSignupForm>
        {/* <SignUp
          buttonText={props.buttonText}
          inputSize={props.inputSize}
          onSignup={onSignup}
        ></SignUp> */}
      </Container>
    </Section>
  );
}

export default LoginSignUpSection;
